import * as Yup from 'yup';

import { enrichmentStatusOptions as defaultEnrichmentStatusOptions } from '../../../defaultFilters';

export const useEnrichmentStatusFilter = ({ setFilters }) => {
  const enrichmentStatusOptions = defaultEnrichmentStatusOptions;

  const formSchema = Yup.object().shape({
    enrichmentStatus: Yup.object().shape({
      label: Yup.string().required(),
      value: Yup.string().required(),
    }),
  });

  const onSubmit = ({ enrichmentStatus }) => {
    setFilters({ enrichmentStatus });
  };

  return {
    formSchema,
    onSubmit,
    enrichmentStatusOptions,
  };
};
